import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/data/site";

export const Process = () => (
  <section id="processo" className="relative border-y border-gold-400/10 bg-navy-900/40">
    <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16"
      >
        <p className="mb-3 font-mono-tech text-xs tracking-[0.3em] text-gold-400">
          02 — COMO FUNCIONA
        </p>
        <h2 className="font-serif-display max-w-2xl text-3xl font-normal leading-tight tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
          Quatro etapas. <em className="gold-text italic">Zero improviso.</em>
        </h2>
      </motion.div>

      <div className="relative grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-transparent via-gold-400/40 to-transparent lg:block" />
        {PROCESS_STEPS.map((s, i) => (
          <motion.div
            key={s.step}
            data-testid={`process-step-${s.step}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group relative"
          >
            <div className="relative z-10 mb-6 flex h-14 w-14 items-center justify-center rounded-full border border-gold-400/50 bg-navy-950 font-mono-tech text-sm text-gold-300 transition-colors duration-500 group-hover:bg-gold-400 group-hover:text-navy-950">
              {s.step}
            </div>
            <h3 className="font-serif-display mb-3 text-xl text-slate-100 sm:text-2xl">
              {s.title}
            </h3>
            <p className="text-sm font-light leading-relaxed text-slate-400">{s.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
